import { TrendingUp, ShoppingBag, Package, DollarSign } from 'lucide-react';

const MockupTienda360 = () => {
  return (
    <div className='mockup mockup--desktop' aria-hidden='true'>
      <div className='mockup-desktop-bar'>
        <span className='mockup-dot mockup-dot--red' />
        <span className='mockup-dot mockup-dot--yellow' />
        <span className='mockup-dot mockup-dot--green' />
        <span className='mockup-desktop-url'>tienda360.app/dashboard</span>
      </div>
      <div className='mockup-desktop-screen'>
        <div className='mockup-desktop-sidebar'>
          <div className='mockup-app-logo mockup-app-logo--retail'>T</div>
          <div className='mockup-sidebar-item mockup-sidebar-item--active' />
          <div className='mockup-sidebar-item' />
          <div className='mockup-sidebar-item' />
          <div className='mockup-sidebar-item' />
        </div>
        <div className='mockup-desktop-main'>
          <div className='mockup-desktop-title'>Resumen del día</div>
          <div className='mockup-kpi-grid'>
            <div className='mockup-kpi'>
              <div className='mockup-kpi-icon'>
                <DollarSign size={14} />
              </div>
              <div className='mockup-kpi-value'>$184.520</div>
              <div className='mockup-kpi-label'>Ventas hoy</div>
            </div>
            <div className='mockup-kpi'>
              <div className='mockup-kpi-icon'>
                <ShoppingBag size={14} />
              </div>
              <div className='mockup-kpi-value'>47</div>
              <div className='mockup-kpi-label'>Tickets</div>
            </div>
            <div className='mockup-kpi'>
              <div className='mockup-kpi-icon'>
                <Package size={14} />
              </div>
              <div className='mockup-kpi-value'>3</div>
              <div className='mockup-kpi-label'>Bajo stock</div>
            </div>
          </div>
          <div className='mockup-chart'>
            <div className='mockup-chart-header'>
              <span>Ventas por hora</span>
              <TrendingUp size={14} />
            </div>
            <div className='mockup-chart-bars'>
              <span style={{ height: '40%' }} />
              <span style={{ height: '60%' }} />
              <span style={{ height: '45%' }} />
              <span style={{ height: '80%' }} />
              <span style={{ height: '70%' }} />
              <span style={{ height: '95%' }} />
              <span style={{ height: '55%' }} />
              <span style={{ height: '75%' }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MockupTienda360;
